module.exports = __webpack_public_path__ + "img/btn4.285f8a55.png";